// extracted by mini-css-extract-plugin
module.exports = {"content":"content__2MzWP","wrapper":"wrapper__bgsrp","block":"block__1ZNQo","button":"button__32Y6P","heading":"heading__1JMaS"};